import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import Checkbox from '../UI/Checkbox';
import MultiCheckbox from '../UI/MultiCheckbox';
import {
  StyledListingsFilter,
  StyledListingsFilterMultiCheckboxWrapper,
  StyledListingsFilterTitle,
} from './Filter.styles';

const Filter = ({
  activeOptions,
  options,
  onChange,
  isMulti = true,
}: {
  activeOptions: string | string[];
  options: {
    name: string;
    label: string;
  }[];
  onChange: (x: string | string[]) => void;
  isMulti: boolean;
}) => {
  const { t } = useTranslation(['listings']);
  return (
    <StyledListingsFilter>
      <StyledListingsFilterTitle>
        {upperFirst(t('listings:filterByStatus'))}
      </StyledListingsFilterTitle>
      <StyledListingsFilterMultiCheckboxWrapper>
        {isMulti ? (
          <MultiCheckbox
            activeOptions={activeOptions as string[]}
            options={options}
            onChange={onChange}
          />
        ) : (
          <Checkbox
            activeOptions={activeOptions as string}
            options={options}
            onChange={onChange}
          />
        )}
      </StyledListingsFilterMultiCheckboxWrapper>
    </StyledListingsFilter>
  );
};

export default Filter;
